module.exports = __webpack_public_path__ + "img/6.8e83b8b0.webp";